import { render, staticRenderFns } from "./batchOrderNotify.vue?vue&type=template&id=b3a3c68a&scoped=true"
import script from "./batchOrderNotify.vue?vue&type=script&lang=ts"
export * from "./batchOrderNotify.vue?vue&type=script&lang=ts"
import style0 from "./batchOrderNotify.vue?vue&type=style&index=0&id=b3a3c68a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a3c68a",
  null
  
)

export default component.exports